<div class="row">
    <div #parent [innerHtml]="data.value"></div>
</div>
